module.exports = __webpack_public_path__ + "img/SC3-About_you.af804734.svg";